import React from 'react';
import { Checkbox, Typography } from '@mui/material';
import StickyHeadTable from 'shared/components/table/StickyHeadTable';
import { UserTableWrapper } from './styled';

/**
 * @param {Object} props
 * @param {Object} props.state
 * @param {Function} props.onChangeRadUserGroup
 * @param {boolean} props.disabled
 * @param {boolean} props.isProfile
 */
export default function AdminRadUserGroupTable(props) {
  const {
    state: { currentGroups, allGroups }, onChangeRadUserGroup, disabled, isProfile,
  } = props;

  function radUserGroupCheckBox(group) {
    const checked = !!currentGroups.find((g) => g.groupname === group.groupname);
    return (
      <Checkbox
        checked={checked}
        onChange={() => onChangeRadUserGroup(group.groupname)}
        disabled={disabled}
      />
    );
  }

  const columns = [{ name: 'Group Name', jsonKey: 'label' }];

  if (!isProfile) {
    columns.push({ name: '', formatter: radUserGroupCheckBox });
  }

  if (allGroups.length === 0) {
    return <Typography sx={{ fontStyle: 'italic' }}>No radius permissions to display</Typography>;
  }

  return (
    <UserTableWrapper>
      <StickyHeadTable
        columns={columns}
        noRowsText=""
        rowId="groupname"
        rows={allGroups}
        striped
      />
    </UserTableWrapper>
  );
}
